import { Component } from '@angular/core';
import { LayoutService } from './service/app.layout.service';
import { ConstanteAngular } from '../app/framework/angular/funciones/ConstanteAngular';
import { Router } from '@angular/router';

@Component({
    selector: 'app-profilemenu',
    templateUrl: './app.profilesidebar.component.html'
})
export class AppProfileSidebarComponent {

    usuario: any

    constructor(public layoutService: LayoutService, private router: Router) { }

    get visible(): boolean {
        return this.layoutService.state.profileSidebarVisible;
    }

    set visible(_val: boolean) {
        this.layoutService.state.profileSidebarVisible = _val;
    }

    ngOnInit(): void {
        this.usuario = JSON.parse(String(localStorage.getItem(ConstanteAngular.JWT_RESPONSE_HEADER)))
    }

    cerrarSesion() {
        localStorage.clear()
        window.location.href = "https://login.ceplan.gob.pe";
        /*let dw = JSON.parse(String(localStorage.getItem(ConstanteAngular.JWT_RESPONSE_FORM)))
        if(dw == "S"){
            localStorage.clear()
            window.location.href = "https://login.ceplan.gob.pe";
        }else{
            localStorage.clear()
            window.location.href = "https://login.ceplan.gob.pe";
        }   */
    }
}